import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MachCoreModalUtilService {
  handleModalResize(
    show: boolean,
    isDesktop: boolean,
    flyoutDesktop?: ElementRef,
    flyoutMobile?: ElementRef
  ): void {
    if (!show) return;
    this.switchModalType(isDesktop, flyoutDesktop, flyoutMobile);
  }

  switchModalType(
    isDesktopView: boolean,
    flyoutDesktop?: ElementRef,
    flyoutMobile?: ElementRef
  ): void {
    if (isDesktopView) {
      flyoutMobile?.nativeElement?.close();
      flyoutDesktop?.nativeElement?.showModal();
    } else {
      flyoutDesktop?.nativeElement?.close();
      flyoutMobile?.nativeElement?.showModal();
    }
  }

  openModal(
    isDesktop: boolean,
    flyoutDesktop?: ElementRef,
    flyoutMobile?: ElementRef
  ): void {
    if (isDesktop) {
      flyoutDesktop?.nativeElement?.showModal();
    } else {
      flyoutMobile?.nativeElement?.showModal();
    }
  }
}
